module.exports = __webpack_public_path__ + "assets/img/busy_6.5e253d51.png";